import React from 'react'
import { Modal, Form, Select, Input, Button, Typography, theme } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { formatDateTime } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text } = Typography
const { Option } = Select

const CompleteTaskModal = ({ isVisible, onCancel, onComplete, form, selectedTask }) => {
  const { token } = theme.useToken()

  return (
    <Modal
      title='Complete Task'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onComplete}
          icon={<CheckOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Mark as Complete
        </Button>
      ]}
    >
      {selectedTask && (
        <div style={{ marginBottom: '20px' }}>
          <Text strong>Task: </Text>
          <Text>{selectedTask.taskDescription}</Text>
          <br />
          <Text strong>Patient: </Text>
          <Text>{selectedTask.patientName}</Text>
          <br />
          <Text strong>Due: </Text>
          <Text>{formatDateTime(selectedTask.dueDate)}</Text>
        </div>
      )}

      <Form form={form} layout='vertical'>
        <Form.Item
          name='completionNotes'
          label='Completion Notes'
          rules={[{ required: true, message: 'Please enter completion notes' }]}
        >
          <Input.TextArea rows={3} placeholder='Enter details about how the task was completed' />
        </Form.Item>

        <Form.Item name='outcomeSummary' label='Outcome Summary'>
          <Input.TextArea rows={2} placeholder='Summarize the outcome or results (if applicable)' />
        </Form.Item>

        <Form.Item name='followUp' label='Follow-up Required' valuePropName='checked'>
          <Select style={{ width: '100%' }}>
            <Option value='none'>None Required</Option>
            <Option value='task'>Create Follow-up Task</Option>
            <Option value='notification'>Notify Physician</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CompleteTaskModal
